import { Component, OnInit } from '@angular/core';
import { WorkflowExec, WorkflowStatus } from 'app/models/workflow-exec';
import { WorkflowExecutionService } from 'app/services/workflow-execution.service';
import { finalize } from 'rxjs/operators';
import { ActivatedRoute } from '@angular/router';
import { StepType } from 'app/models/workflow-step';
import { Scope } from 'app/models/scope';
import { ToastService } from 'ng-uikit-pro-standard';
import { getExecVariableValue } from 'app/helpers/utils';

@Component({
  selector: 'app-workflow-status-info',
  templateUrl: './workflow-status-info.component.html',
  styleUrls: ['./workflow-status-info.component.scss']
})
export class WorkflowStatusInfoComponent implements OnInit {

  isLoading: boolean = false;
  workflowExec: WorkflowExec = null;

  constructor(private workflowExecutionService: WorkflowExecutionService, private activatedRoute: ActivatedRoute, private toastService: ToastService) {
    this.activatedRoute.params.subscribe(params => {
      const workflowExecId: number = +params['id'];

      this.isLoading = true;
      this.workflowExecutionService.getById(workflowExecId).pipe(finalize(() => {
        this.isLoading = false;
      })).subscribe((w) => {
        this.workflowExec = w;
      }, (err) => {
        /** @todo handle error */
      });
    });
  }

  ngOnInit() {

  }

  currentStepTargetsString() {
    if (this.workflowExec.current_step.workflow_step_type_id == StepType.APPROVAL)
      return 'Approver(s)';
    else if (this.workflowExec.current_step.workflow_step_type_id == StepType.REVIEW)
      return 'Reviewer(s)';
    
    return 'Assignee(s)';
  }

  public get workflowStatus() : typeof WorkflowStatus {
    return WorkflowStatus;
  }

  getWorkflowStatusLabel(status: WorkflowStatus) {
    var result = '';
    switch (status) {
      case WorkflowStatus.WORKFLOW_STATUS_COMPLETED:
        result = 'Completed';
        break;
      case WorkflowStatus.WORKFLOW_STATUS_IN_PROGRESS:
          result = 'In Progress';
          break;
      case WorkflowStatus.WORKFLOW_STATUS_PROCESSING:
        result = 'Processing';
        break;
      case WorkflowStatus.WORKFLOW_STATUS_TIMED_OUT:
        result = 'Timed-Out';
        break;
    }

    return result;
  }

  notify() {
    this.isLoading = true;
    this.workflowExecutionService.notifyCurrentStepTargets(this.workflowExec.id).pipe(finalize(()=>{
      this.isLoading = false;
    })).subscribe(()=>{
      this.toastService.success('Nofitication Sent!');
    });
  }  
}
